
import { useState } from "react";
import { Typography, Button, Card } from "@material-ui/core";
import EstilosGlobales from "../toremp/EstilosGlobales.jsx";
import { useSpring, animated } from "react-spring";

export default function CardDn(props) {
    const [Hover, setHover] = useState(false);

    const EstilosContCard = useSpring({
        height: "200px",
        zIndex:"50",
        transform: Hover ? "translate(0,-60px)" : "translate(0,0px)",
    });
    const EstilosBoton = useSpring({
        bottom: "100px",
        position: "absolute",
        opacity: Hover ? "1" : "0",
        config: { duration: 600 },
    });
    const EstiloCapaImagen = useSpring({
        top: "0px",
        zIndex: "20",
        backgroundColor:"#000",
        opacity:Hover?"0.5":"0"
    });
    return (
        <div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={props.className}
        >
            <Card
                className="position-relative overflow-hidden"
                style={{
                    borderRadius: "12px 12px 12px 12px",
                    cursor: "pointer",
                    height: "250px",
                }}
            >
                <div
                    className="ContImagen position-relative overflow-hidden"
                    style={{
                        height: "190px",
                    }}
                >
                    <img
                        className="img-fluid position-relative"
                        src={props.imagen}
                        alt="..."
                        style={{
                            top: "50%",
                            transform: "translate(0,-50%)",
                            zIndex: "10",
                        }}
                    />
                    <animated.div
                        className="position-absolute w-100 h-100"
                        style={EstiloCapaImagen}
                    ></animated.div>
                </div>
                <div className="ContCard">
                    <animated.div
                        className="position-relative bg-white"
                        style={EstilosContCard}
                    >
                        <Typography
                            className="font-weight-bold text-left px-3 pt-3 text-center"
                            style={{
                                fontSize: "18px",
                                color: EstilosGlobales.colorSecundario,
                            }}
                        >
                            {props.titulo}
                        </Typography>
                        <Typography
                            className="px-3 pb-3 text-secondary"
                            variant="body2"
                        >
                            {props.subtitulo}
                        </Typography>
                        <animated.div
                            className="position-absolute w-100 px-4 text-center"
                            style={EstilosBoton}
                        >
                            <Button
                                size="small"
                                variant="contained"
                                className="text-white w-100"
                                style={{
                                    backgroundColor:
                                        EstilosGlobales.colorPrimario,
                                    borderRadius:"12px 12px 12px 12px"
                                }}
                            >
                                Ver 
                            </Button>
                        </animated.div>
                    </animated.div>
                </div>
            </Card>
        </div>
    );
}
